import { InterwillDto } from '../../../entities/interwills';
import { SecureJsonBase } from '../secure-json/core/secure-json-base';

import { SJCollection } from './core/SJCollection';
import { AssetDto } from './models/asset.dto';
import { AssistantMnemonicDto } from './models/assistant-mnemonic.dto';
import { DtoId } from './models/base.dto';
import { BeneficiaryDto } from './models/beneficiary.dto';
import { ContactDto } from './models/contact.dto';
import { DelegatingRequestDto } from './models/delegating-request.dto';
import { AssetInformationDocumentDto } from './models/document/asset-information.document.dto';
import { BeneficiaryPersonalDataDocumentDto } from './models/document/beneficiary-personal-data.document.dto';
import { PrivateDocumentDto } from './models/document/private.document.dto';
import { EncryptedFileKeyDto } from './models/encrypted-file-key.dto';
import { FileMetaInfoDto } from './models/file-meta-info.dto';
import { InboxDto } from './models/inbox.dto';
import { MyHubDto } from './models/my-hub.dto';
import { NotificationDto } from './models/notification.dto';
import { PersonalIdentifierDocumentDto } from './models/personalIdentifiersDocuments/personalIdentifiersDocuments.dto';
import { ScenarioMetaInfoDto } from './models/scenario-meta-info.dto';
import { SoweDto } from './models/sowe/sowe.dto';
import { SoweAttachmentDto } from './models/sowe/sowe-attachment.dto';

export enum CollectionName {
  // Documents
  PERSONAL_IDENTIFIERS_DOCUMENTS = 'personalIdentifiersDocuments',
  PRIVATE_DOCUMENTS = 'privateDocuments',
  BENEFICIARY_PERSONAL_DATA_DOCUMENT = 'beneficiaryPersonalDataDocuments',
  ASSET_INFORMATION_DOCUMENT = 'assetInformationDocument',

  //
  ASSETS = 'assets',
  CONTACTS = 'contacts',
  BENEFICIARIES = 'beneficiaries',
  ASSISTANT_MNEMONIC = 'assistantMnemonic',
  DELEGATING_REQUESTS = 'delegatingRequests',
  MY_HUB = 'myHub',
  SCENARIO_META_INFO = 'scenarioMetaInfos',
  NOTIFICATION = 'notification',

  SOWE = 'sowe',
  SOWE_ATTACHMENTS = 'soweAttachments',

  ENCRYPTED_FILE_KEY = 'encryptedFileKey',
  FILE_META_INFO = 'fileMetaInfos',

  INTERWILLS = 'interwills',
  INBOX = 'inbox',

  // MIGRATIONS = 'migrations',
  // UNKNOWN_DOCUMENT = 'unknownDocuments',
  // PASSPORT_DOCUMENT = 'passportDocuments',
  // SOWE_ATTACHED_PERSONAL_IDENTIFIER = 'soweAttachedPersonalIdentifier',
}

export type CollectionToDtoMap = {
  [CollectionName.ASSET_INFORMATION_DOCUMENT]: AssetInformationDocumentDto;
  [CollectionName.ASSETS]: AssetDto;
  [CollectionName.ASSISTANT_MNEMONIC]: AssistantMnemonicDto;
  [CollectionName.BENEFICIARIES]: BeneficiaryDto;
  [CollectionName.BENEFICIARY_PERSONAL_DATA_DOCUMENT]: BeneficiaryPersonalDataDocumentDto;
  [CollectionName.CONTACTS]: ContactDto;
  [CollectionName.DELEGATING_REQUESTS]: DelegatingRequestDto;
  [CollectionName.ENCRYPTED_FILE_KEY]: EncryptedFileKeyDto;
  [CollectionName.FILE_META_INFO]: FileMetaInfoDto;
  [CollectionName.INBOX]: InboxDto;
  [CollectionName.INTERWILLS]: InterwillDto;
  [CollectionName.MY_HUB]: MyHubDto;
  [CollectionName.NOTIFICATION]: NotificationDto;
  [CollectionName.PERSONAL_IDENTIFIERS_DOCUMENTS]: PersonalIdentifierDocumentDto;
  [CollectionName.PRIVATE_DOCUMENTS]: PrivateDocumentDto;
  [CollectionName.SCENARIO_META_INFO]: ScenarioMetaInfoDto;
  [CollectionName.SOWE_ATTACHMENTS]: SoweAttachmentDto;
  [CollectionName.SOWE]: SoweDto;
};

export type CollectionsSjMap = Map<CollectionName, SecureJsonBase>;

export type CollectionToSjMap = {
  [K in keyof CollectionToDtoMap]: SJCollection<K>;
};

export type CollectionData<T = keyof CollectionToDtoMap> = T extends keyof CollectionToDtoMap
  ? { name: T; items: CollectionToDtoMap[T][] }
  : never;
export type CollectionDataList = CollectionData[];

export type CollectionItemRef = {
  colName: CollectionName;
  id: DtoId;
};

export type SerializedCollections = Record<CollectionName, { data: SerializedCollection }>;
export type SerializedCollection = string;
